import {
  BoxSelect,
  Captions,
  Cloud,
  Cpu,
  Crosshair,
  MessageCircleQuestion,
  Microscope,
  Shapes,
  Sparkles,
} from "lucide-react";

export interface MenuItem {
  title: string;
  url: string;
  description?: string;
  icon?: React.ReactNode;
  items?: MenuItem[];
  external?: boolean;
  prefetch?: boolean;
}

const skillItems: MenuItem[] = [
  {
    title: "Detect",
    url: "/skills/detect",
    icon: <BoxSelect className="size-3.5 shrink-0" />,
  },
  {
    title: "Caption",
    url: "/skills/caption",
    icon: <Captions className="size-3.5 shrink-0" />,
  },
  {
    title: "Point",
    url: "/skills/point",
    icon: <Crosshair className="size-3.5 shrink-0" />,
  },
  {
    title: "Segment",
    url: "/skills/segment",
    icon: <Shapes className="size-3.5 shrink-0" />,
  },
  {
    title: "Query",
    url: "/skills/query",
    icon: <MessageCircleQuestion className="size-3.5 shrink-0" />,
  },
];

// This is the content for the header, that lives in either the desktop or mobile header
export const headerMenu: MenuItem[] = [
  {
    title: "Products",
    url: "#",
    items: [
      {
        title: "Models",
        description: "State-of-the-art vision language models",
        icon: <Sparkles className="size-5 shrink-0" />,
        url: "/p/models",
        items: skillItems,
      },
      {
        title: "Lens",
        description: "Fine-tune Moondream for your use case",
        icon: <Microscope className="size-5 shrink-0" />,
        url: "/p/lens",
      },
      {
        title: "Photon",
        description: "High-performance local inference engine",
        icon: <Cpu className="size-5 shrink-0" />,
        url: "/p/photon",
      },
      {
        title: "Cloud",
        description: "Managed inference in the cloud",
        icon: <Cloud className="size-5 shrink-0" />,
        url: "/p/cloud",
      },
    ],
  },
  {
    title: "Docs",
    url: "https://docs.moondream.ai",
    external: false,
  },
  {
    title: "Playground",
    url: "/playground",
    prefetch: true,
  },
  {
    title: "Pricing",
    url: "/pricing",
    prefetch: true,
  },
  {
    title: "Blog",
    url: "/blog",
    prefetch: true,
  },
];

export const userMenu: MenuItem[] = [
  {
    title: "Console",
    url: "/me/dashboard",
  },
];
